import React from "react";
const autobind = require("class-autobind").default;
import { FormGroup } from "../group/index";
import { Input } from "../input/index";
import { Button } from "../../button/index";
import { FaMinusCircle, FaCopy } from "react-icons/fa";
import { InputBox } from "../input.box/index";
import { Tooltip } from "../../tooltip/index";
import { Modal } from "../../layout/modal/index";
import { ModalContent } from "../../layout/modal/content";
import { DateTimePicker } from "../datetime/index";
import moment from "moment-timezone";
export class DateTimeRanges extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            modal: null,
            modal_type: "start",
        };
    }
    setModal(modal, modal_type) {
        this.setState({ modal, modal_type });
    }
    copy(i) {
        const values = [...this.props.values];
        const value = { ...values[i] };
        values.push(value);
        this.props.onChange(values);
    }
    remove(i) {
        const values = [...this.props.values];
        values.splice(i, 1);
        this.props.onChange(values);
    }
    change(i, key, value) {
        const values = [...this.props.values];
        values[i][key] = value;
        this.props.onChange(values);
    }
    render() {
        const { values, allowNone, locale, timezone, formats } = this.props;
        const { modal, modal_type } = this.state;
        const dtFormat = `${formats.date} ${formats.time}`;
        return (React.createElement("div", { className: "m-t-2" },
            values.map((value, i) => {
                return (React.createElement("div", { key: i, className: "flex-line", style: { alignItems: "flex-end" } },
                    React.createElement(InputBox, { className: "no-round width32 text-center" },
                        React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, i + 1)),
                    React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                        React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Start" : null, small_title: true, no_border: true },
                            React.createElement(Input, { type: "text", value: value.start ? moment.tz(value.start, timezone).format(dtFormat) : "", placeholder: "Click to select", className: "no-round width200", onClick: () => this.setModal(i, "start"), readOnly: true, required: true })),
                        React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "End" : null, small_title: true, no_border: true },
                            React.createElement(Input, { type: "text", value: value.end ? moment.tz(value.end, timezone).format(dtFormat) : "", placeholder: "Click to select", className: "no-round width200", onClick: () => this.setModal(i, "end"), readOnly: true, required: true }))),
                    (allowNone || values.length !== 1) &&
                        React.createElement(Tooltip, { text: "Delete", width: 65, position: "top" },
                            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.remove(i) },
                                React.createElement(FaMinusCircle, null))),
                    React.createElement(Tooltip, { text: "Copy", width: 65, position: "top" },
                        React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.copy(i) },
                            React.createElement(FaCopy, null)))));
            }),
            React.createElement(Modal, { active: modal !== null, width: 265, closeButton: false, close: () => this.setModal(null, "start") }, (modal !== null) && (React.createElement(ModalContent, null,
                React.createElement(DateTimePicker, { locale: locale, timezone: timezone, onSelect: (millis) => {
                        this.change(modal, modal_type, millis);
                        this.setModal(null, "start");
                    } }))))));
    }
}
//# sourceMappingURL=index.js.map